import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    // WEBCOM-5519: 최초 admin 셋업 관련 상태
    setupRequired: null,    // null=미조회, true=셋업 필요, false=불필요
    setupLoading: false,
    setupSuccess: false,
    setupError: null,
    // 비밀번호는 맞았고 코드만 남은 상태. 이 값이 true 라도 <b>로그인된 것이 아니다</b> -
    // 서버 세션에는 아직 인증이 없다. 화면 단계를 가리키는 값일 뿐이다.
    mfaRequired: false,
    // 로그인한 계정. 화면을 그리는 데만 쓴다 - 권한 판단은 서버가 매 요청마다 다시 한다.
    me: null,
    meLoading: false,
};

export const sessionKey = "JSESSIONID"

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setReset: (state) => {
            Object.assign(state, initialState);
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        // 로그아웃. 실제 처리는 sAuth 사가가 한다 - 서버 세션을 끊어야 해서 비동기다.
        // 여기서 하던 일(localStorage 를 비우고 새로고침)은 서버를 부르지 않아
        // 세션과 쿠키가 그대로 살아남았다. 세션 쿠키는 HttpOnly 라 여기서는 못 지운다.
        fetchSignOutRequest : () => {},

        //signIn
        fetchSignInRequest : (state) => {
            setReset()
            state.loading = true;
        },
        fetchSignInSuccess : (state) => {
            // 사이드이펙트(localStorage, navigation)는 sAuth 사가에서 처리
        },
        // 비밀번호를 지났고 코드가 메일로 나갔다.
        fetchSignInMfaRequired : (state) => {
            state.mfaRequired = true;
            state.error = null;
        },

        //signIn 2단계
        fetchVerifyMfaRequest : (state) => {
            state.loading = true;
        },
        fetchVerifyMfaFailure : (state, action) => {
            state.error = action.payload;
        },
        // 시도를 다 썼거나 만료됐다. 비밀번호부터 다시 받아야 한다.
        setMfaRestart : (state) => {
            state.mfaRequired = false;
        },
        fetchResendMfaRequest : () => {},
        fetchSignInFailure : (state, action) => {
            state.error = action.payload;
        },

        // WEBCOM-5519: 최초 admin 셋업 필요 여부 조회
        fetchSetupRequiredRequest: (state) => {
            state.setupRequired = null;
        },
        fetchSetupRequiredSuccess: (state, action) => {
            state.setupRequired = !!action.payload;
        },
        fetchSetupRequiredFailure: (state, action) => {
            state.setupRequired = false;
            state.setupError = action.payload;
        },

        // WEBCOM-5519: 최초 admin 등록 요청
        fetchInitialSetupRequest: (state) => {
            state.setupLoading = true;
            state.setupSuccess = false;
            state.setupError = null;
        },
        fetchInitialSetupSuccess: (state) => {
            state.setupLoading = false;
            state.setupSuccess = true;
            state.setupRequired = false;
        },
        // 로그인한 계정 조회
        fetchMeRequest: (state) => {
            state.meLoading = true;
        },
        fetchMeSuccess: (state, action) => {
            state.me = action.payload;
            state.meLoading = false;
        },
        fetchMeFailure: (state) => {
            // 실패해도 화면은 떠야 한다. 파트너 기준(권한 없음)으로 그린다 - 본사 전용 항목을
            // 잘못 보여주는 것보다 안 보여주는 쪽이 낫다.
            state.me = null;
            state.meLoading = false;
        },
        fetchInitialSetupFailure: (state, action) => {
            state.setupLoading = false;
            state.setupError = action.payload;
        },
    }
});

export const {
    setReset,
    setLoading,
    fetchSignOutRequest,
    fetchSignInRequest,
    fetchSignInSuccess,
    fetchSignInMfaRequired,
    fetchVerifyMfaRequest,
    fetchVerifyMfaFailure,
    setMfaRestart,
    fetchResendMfaRequest,
    fetchSignInFailure,
    fetchSignInFinally,
    fetchSetupRequiredRequest,
    fetchSetupRequiredSuccess,
    fetchSetupRequiredFailure,
    fetchInitialSetupRequest,
    fetchInitialSetupSuccess,
    fetchInitialSetupFailure,
    fetchMeRequest,
    fetchMeSuccess,
    fetchMeFailure,
} = authSlice.actions;

export default authSlice.reducer;